export default __webpack_public_path__ + "static/media/shield.7d4980f8.png";